module.exports = "<div popover=\"{{textTip}}\" popover-trigger=\"mouseenter\"><label style=\"width:100%; max-height: 20px\" ng-bind=\"textTip\" data-ellipsis data-ellipsis-symbol=\"...\" ></label></div>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/directives_templates/ellipsis_tooltip.html
// module id = 172
// module chunks = 0